import { combineReducers } from "redux";
import accountOverviewCompanyReducer from "../company/store/reducer";
import competitiveLandscapeResultsReducer from "../competitive-landscape/store/reducer";
import accountOverviewSharedReducer from "../shared/store/reducer";
import type { AccountOverviewState } from "./types";

const accountOverviewReducer = combineReducers<AccountOverviewState>({
    company: accountOverviewCompanyReducer,
    shared: accountOverviewSharedReducer,
    competitiveLandscape: competitiveLandscapeResultsReducer,
});

export default accountOverviewReducer;
